import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { fetchAssetCategories, createAssetCategory } from '../../redux/api';
import { su } from './stockUi';

export async function resolveAssetCategory({ selectedName = '', newName = '' }) {
  const selected = String(selectedName || '').trim();
  const created = String(newName || '').trim();
  if (selected && created) {
    const error = new Error('BOTH');
    error.code = 'BOTH';
    throw error;
  }
  if (!created) return selected;
  const response = await createAssetCategory({ name: created });
  return response?.data?.name || created;
}

const AssetCategoryFields = ({
  selectedName = '',
  newName = '',
  onChange,
}) => {
  const [categories, setCategories] = useState([]);
  const hasSelected = Boolean(String(selectedName || '').trim());
  const hasNew = Boolean(String(newName || '').trim());

  const loadCategories = async () => {
    try {
      const response = await fetchAssetCategories();
      setCategories(Array.isArray(response?.data) ? response.data : []);
    } catch (error) {
      setCategories([]);
    }
  };

  useEffect(() => {
    loadCategories();
  }, []);

  return (
    <>
      <div>
        <label className={su.label}>Kategorija</label>
        <select
          value={selectedName || ''}
          disabled={hasNew}
          onChange={(e) => onChange?.({ selectedName: e.target.value, newName: '' })}
          className={`${su.input}${hasNew ? ' opacity-50 cursor-not-allowed' : ''}`}
        >
          <option value="">Izaberi kategoriju...</option>
          {selectedName && !categories.some((c) => c.name === selectedName) ? (
            <option value={selectedName}>{selectedName}</option>
          ) : null}
          {categories.map((category) => {
            const id = category.id || category._id;
            return (
              <option key={id} value={category.name}>
                {category.name}
              </option>
            );
          })}
        </select>
      </div>
      <div>
        <label className={su.label}>Nova kategorija</label>
        <input
          type="text"
          value={newName || ''}
          disabled={hasSelected}
          onChange={(e) => onChange?.({ selectedName: '', newName: e.target.value })}
          placeholder="Opciono, npr. alat, nameštaj..."
          className={`${su.input}${hasSelected ? ' opacity-50 cursor-not-allowed' : ''}`}
        />
      </div>
    </>
  );
};

export const showAssetCategoryConflict = () => {
  toast.error('Izaberite postojeću kategoriju ili unesite novu, ne obe u isto vreme.');
};

export default AssetCategoryFields;
